import { combineReducers } from 'redux'

import getCarePlansList from './getCarePlansList'
import createCarePlan from './createCarePlan'
import updateCarePlan from './updateCarePlan'
import deleteCarePlan from './deleteCarePlan'
import discontinueService from './discontinueService'
import reactivateService from './reactivateService'
import adjustServiceSchedule from './adjustServiceSchedule'
import addService from './addService'
import getCarePlanVersions from './getCarePlanVersions'
import getCarePlanServices from './getCarePlanServices'

import { slice as getCarePlansListSlice } from './getCarePlansList'
import { slice as createCarePlanSlice } from './createCarePlan'
import { slice as updateCarePlanSlice } from './updateCarePlan'
import { slice as deleteCarePlanSlice } from './deleteCarePlan'
import { slice as discontinueServiceSlice } from './discontinueService'
import { slice as reactivateServiceSlice } from './reactivateService'
import { slice as adjustServiceScheduleSlice } from './adjustServiceSchedule'
import { slice as addServiceSlice } from './addService'
import { slice as getCarePlanVersionsSlice } from './getCarePlanVersions'
import { slice as getCarePlanServicesSlice } from './getCarePlanServices'

const carePlansRootReducer = combineReducers({
  ...getCarePlansList,
  ...createCarePlan,
  ...updateCarePlan,
  ...deleteCarePlan,
  ...discontinueService,
  ...reactivateService,
  ...adjustServiceSchedule,
  ...addService,
  ...getCarePlanVersions,
  ...getCarePlanServices
})

export const carePlanSagas = [
  ...getCarePlansListSlice.sagas,
  ...createCarePlanSlice.sagas,
  ...updateCarePlanSlice.sagas,
  ...deleteCarePlanSlice.sagas,
  ...discontinueServiceSlice.sagas,
  ...reactivateServiceSlice.sagas,
  ...adjustServiceScheduleSlice.sagas,
  ...addServiceSlice.sagas,
  ...getCarePlanVersionsSlice.sagas,
  ...getCarePlanServicesSlice.sagas
]

export const carePlanActions = {
  ...getCarePlansListSlice.actions,
  ...createCarePlanSlice.actions,
  ...updateCarePlanSlice.actions,
  ...deleteCarePlanSlice.actions,
  ...discontinueServiceSlice.actions,
  ...reactivateServiceSlice.actions,
  ...adjustServiceScheduleSlice.actions,
  ...addServiceSlice.actions,
  ...getCarePlanVersionsSlice.actions,
  ...getCarePlanServicesSlice.actions
}

export default carePlansRootReducer
